;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useEffect } from 'react';

// Registreert de service worker (nodig voor pushmeldingen).
// Een mislukte registratie (netwerkfout, 503 tijdens deploy, privémodus) is niet erg: er zijn dan gewoon geen
// pushmeldingen. register() geeft een Promise terug, dus een try/catch volstaat niet: zonder .catch() wordt het
// een unhandled rejection die in Sentry belandt (SYNERGIEFRONTENDS-2CM, 2CK, 2CP).
const useServiceWorker = (): void => {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      console.warn('Service worker registration failed', error);
    });
  }, []);
};

export default useServiceWorker;
